import { computed, isRef } from "vue";
import statusStore from "../stores/statusStore.js";

var defaults = { left: "Left", right: "Right" };

// Accepts a string ("left"/"right"), a Ref, or a getter function. Using a
// plain string captures the value at call time, which breaks for components
// whose `side` prop can change (e.g. SideCard now that the dashboard side
// selector swaps it). Pass `() => props.side` from inside `<script setup>`
// to stay reactive.
export function useSideName(sideOrGetter) {
	return computed(() => {
		var side;
		if (typeof sideOrGetter === "function") { side = sideOrGetter(); }
		else if (isRef(sideOrGetter)) { side = sideOrGetter.value; }
		else { side = sideOrGetter; }
		var s = statusStore.data.data?.config?.sideNames?.[side];
		return s ?? defaults[side] ?? side;
	});
}

export function useAllSideNames() {
	return computed(() => {
		var sn = statusStore.data.data?.config?.sideNames ?? {};
		return {
			left: sn.left ?? defaults.left,
			right: sn.right ?? defaults.right,
		};
	});
}
